<template>
  <vx-card title="شماره تلفن ها" class="h-100%">
    <vs-row v-if="phones.length > 0" class="mb-3">
      <vs-col class="mb-3" v-for="(item, index) in phones" :key="index">
        {{ "شماره " + (index + 1) }}
        <div style="display: flex; align-items: center">
          <vs-input
            v-model="item.label"
            class="w-100 mt-1"
            placeholder="عنوان"
          />
          <vs-input
            v-model="item.phone"
            class="w-100 mt-1 ml-3"
            placeholder="شماره همراه/ثابت"
          />
          <vs-button
            @click="deletePhone(index)"
            color="danger"
            icon-pack="feather"
            icon="icon-x"
            class="px-5 ml-2"
          />
        </div>
      </vs-col>
    </vs-row>
    <vs-button @click="addPhone" color="secondary"> ایجاد شماره </vs-button>
  </vx-card>
</template>

<script>
import VxCard from "../../../components/VxCard.vue";
export default {
  components: { VxCard },
  name: "Phones.vue",
  data() {
    const list = this.phonesData?.map((item) => {
      return item.phone
        ? item
        : {
            phone: item,
            label: "",
          };
    });

    return {
      phones: list || [],
    };
  },
  methods: {
    addPhone() {
      this.phones.push({
        phone: "",
        label: "",
      });
    },
    getPhones() {
      return this.phones;
    },
    deletePhone(index) {
      this.phones = this.phones.filter((item, i) => i !== index);
    },
  },
  props: {
    phonesData: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="sass">
</style>